import React from "react";
import { LINKS, LOGOS } from "@/constants/links";
import { ArrowUpRight, Flame } from "lucide-react";

export const BackerkitBanner = () => {
  return (
    <section
      id="launch"
      data-testid="backerkit-banner"
      className="relative overflow-hidden backerkit-strip"
    >
      <div className="relative mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
        <div className="grid items-center gap-12 md:grid-cols-[auto_1fr_auto]">
          {/* Left: God Complex logo mark */}
          <div className="flex justify-center md:justify-start">
            <div className="relative">
              <div
                aria-hidden="true"
                className="absolute inset-0 -m-6 rounded-full"
                style={{
                  background:
                    "radial-gradient(circle, rgba(201,168,124,0.18), transparent 70%)",
                }}
              />
              <img
                src={LOGOS.godComplex}
                alt="God Complex"
                className="invert-logo relative h-32 w-32 object-contain md:h-40 md:w-40"
                data-testid="banner-godcomplex-logo"
              />
            </div>
          </div>

          {/* Middle: copy */}
          <div>
            <p className="eyebrow flex items-center gap-3">
              <Flame className="h-3.5 w-3.5" /> Now Live on BackerKit
            </p>
            <h2
              data-testid="banner-title"
              className="font-serif-display mt-4 text-4xl leading-tight text-[#F2EFEB] sm:text-5xl"
            >
              The <em className="italic text-[#C9A87C]">God Complex</em> launch
              is being woven.
            </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-[#A39D95]">
              An urban-fantasy TTRPG of newly awakened Immortals in a modern
              world — d6 dice pools, Gloriae, and a Humanity score tugging
              against a growing God Complex. Follow the BackerKit page for
              launch alerts, reward previews, and early-bird signals.
            </p>
          </div>

          {/* Right: CTA */}
          <div className="flex md:justify-end">
            <a
              href={LINKS.backerkit}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="banner-backerkit-cta"
              className="btn-primary"
            >
              Notify Me on BackerKit
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="divider-thread" />
    </section>
  );
};

export default BackerkitBanner;
